import { TOKEN_KEY, REFRESH_TOKEN_KEY } from '@/config/constants';
import { storage } from '@/utils/storage';

import type { User } from '../types/auth.types';

export const USER_KEY = 'ies_auth_user';

export function getUser(): User | null {
  return storage.get<User>(USER_KEY);
}

export function setLocalUser(user: User): void {
  storage.set(USER_KEY, user);
}

export function clearLocalUser(): void {
  storage.remove(USER_KEY);
}

export function getToken(): string | null {
  return storage.get<string>(TOKEN_KEY);
}

export function getRefreshToken(): string | null {
  return storage.get<string>(REFRESH_TOKEN_KEY);
}

export function setTokens(accessToken: string, refreshToken?: string | null): void {
  storage.set(TOKEN_KEY, accessToken);
  if (refreshToken) {
    storage.set(REFRESH_TOKEN_KEY, refreshToken);
  } else {
    storage.remove(REFRESH_TOKEN_KEY);
  }
}

export function clearTokens(): void {
  storage.remove(TOKEN_KEY);
  storage.remove(REFRESH_TOKEN_KEY);
}

/** Giải mã payload JWT (chuẩn Base64URL; không dùng `atob` trực tiếp lên segment). */
function decodeJwtPayload(token: string): { exp?: number } | null {
  try {
    const segment = token.split('.')[1];
    if (!segment) return null;
    const base64 = segment.replace(/-/g, '+').replace(/_/g, '/');
    const padded = base64 + '='.repeat((4 - (base64.length % 4)) % 4);
    return JSON.parse(atob(padded)) as { exp?: number };
  } catch {
    return null;
  }
}

/**
 * `true` nếu token đã quá `exp` (theo đồng hồ máy client).
 */
export function isTokenExpired(token: string): boolean {
  const payload = decodeJwtPayload(token);
  if (!payload) return true;
  if (typeof payload.exp !== 'number') return false;
  return payload.exp * 1000 < Date.now();
}

/**
 * Thời điểm hết hạn của access JWT (epoch ms). `null` nếu không đọc được `exp`.
 */
export function getAccessTokenExpiryMs(token: string): number | null {
  const payload = decodeJwtPayload(token);
  if (!payload || typeof payload.exp !== 'number') return null;
  return payload.exp * 1000;
}
